/*
 * PUNCH PRODUCT CARD — WHOLE CARD CLICK
 * Additive only. No hover, slider, blend, image or MutationObserver logic.
 *
 * Makes otherwise non-interactive card areas clickable using the
 * product URL already present in .punch-product-card__info-link.
 *
 * Protected:
 * - Existing links
 * - TRY ON
 * - Swatch King / swatches
 * - Add to Cart
 * - Buttons, forms, inputs, selects
 * - Mobile horizontal image swipes
 */

(() => {
  'use strict';

  const CARD_SELECTOR = 'article.punch-product-card';

  const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'form',
    'label',
    'summary',
    '[role="button"]',
    '[contenteditable="true"]',
    'variant-swatch-king',
    '.punch-card-price-row__swatches',
    '.swatch-view',
    '.swatch-view-item',
    '.swatch-single',
    '.swatches'
  ].join(',');

  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let moved = false;
  let suppressUntil = 0;

  document.addEventListener('pointerdown', (event) => {
    const card = event.target.closest?.(CARD_SELECTOR);
    if (!card) return;

    pointerId = event.pointerId;
    startX = event.clientX;
    startY = event.clientY;
    moved = false;
  }, { passive: true });

  document.addEventListener('pointermove', (event) => {
    if (pointerId === null || event.pointerId !== pointerId) return;

    const dx = event.clientX - startX;
    const dy = event.clientY - startY;

    if (Math.hypot(dx, dy) > 8) {
      moved = true;
    }
  }, { passive: true });

  const finishPointer = (event) => {
    if (pointerId === null || event.pointerId !== pointerId) return;

    if (moved) {
      suppressUntil = Date.now() + 500;
    }

    pointerId = null;
    moved = false;
  };

  document.addEventListener('pointerup', finishPointer, { passive: true });
  document.addEventListener('pointercancel', finishPointer, { passive: true });

  document.addEventListener('click', (event) => {
    const card = event.target.closest?.(CARD_SELECTOR);
    if (!card) return;

    if (Date.now() < suppressUntil) return;

    /* Let all existing controls and links behave normally. */
    if (event.target.closest?.(INTERACTIVE_SELECTOR)) return;

    const productLink = card.querySelector('.punch-product-card__info-link[href]');
    if (!productLink) return;

    const href = productLink.href;
    if (!href) return;

    window.location.assign(href);
  });
})();
